import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/common/Logo";
import { useAuth } from "@/lib/auth";
import { humanError } from "@/lib/api";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ tenant_name: "", name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  function on(k) { return (e) => setForm({ ...form, [k]: e.target.value }); }

  async function onSubmit(e) {
    e.preventDefault();
    if (form.password.length < 8) return toast.error("Password must be at least 8 characters");
    setBusy(true);
    try {
      await signup(form);
      toast.success("Workspace created — welcome!");
      nav("/app", { replace: true });
    } catch (err) {
      toast.error(humanError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="hs-mint-gradient flex min-h-screen items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center"><Logo /></div>
        <div className="rounded-2xl border border-[#E4E9EF] bg-white p-8 hs-card-shadow">
          <h1 className="font-display text-2xl font-bold text-[#0B2B33]">Create your workspace</h1>
          <p className="mt-1 text-sm text-[#43535E]">Starts on Standard. Upgrade any time.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <Field label="Workspace name" testid="signup-tenant-input" value={form.tenant_name} onChange={on("tenant_name")} placeholder="Acme Marketing" required />
            <Field label="Your name" testid="signup-name-input" value={form.name} onChange={on("name")} placeholder="Alex Doe" required />
            <Field label="Work email" testid="signup-email-input" type="email" value={form.email} onChange={on("email")} placeholder="you@company.com" required />
            <Field label="Password" testid="signup-password-input" type="password" value={form.password} onChange={on("password")} placeholder="At least 8 characters" required />
            <button type="submit" disabled={busy} data-testid="signup-submit-button" className="hs-btn-primary w-full disabled:opacity-60">
              {busy ? "Creating…" : "Create workspace"}
            </button>
          </form>
          <p className="mt-5 text-center text-sm text-[#43535E]">
            Already have an account? <Link to="/login" className="font-semibold text-[#1F5FD8] hover:underline" data-testid="signup-login-link">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

function Field({ label, testid, ...rest }) {
  return (
    <div>
      <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-[#8A97A0]">{label}</label>
      <input
        data-testid={testid}
        className="w-full rounded-lg border border-[#E4E9EF] px-3 py-2.5 text-sm text-[#0B2B33] focus:border-[#1F5FD8] focus:outline-none focus:ring-2 focus:ring-[#1F5FD8]/20"
        {...rest}
      />
    </div>
  );
}
